const {
	fillWithDomElements,
	fillWithDomElementsAll,
	awaitNextFrame,
	setClassAll,
	awaitEventOnCondition,
	trackGtm,
	trackGtm4,
} = require('util/functions');
const { DIRECTION_ALL } = require('util/consts');
const asyncImport = require('util/asyncImport').default;
const { default: WheelCursor } = require('./WheelCursor');
const { default: registerCancelable } = require('util/cancellableTask');

const CLASS_ACTIVE = 'active';
const CLASS_NO_DISPLAY = 'no-display';
const CLASS_CONTROLLED = 'controlled';

const CLASS_WHEEL = 'interactive-wheel--wheel';
const CLASS_WHEEL_CONTAINER = 'interactive-wheel--wheel-container';
const CLASS_BACK_BUTTON = 'interactive-wheel--back-button';
const CLASS_TOUCH_ZONE = 'interactive-wheel--touch';

const CLASS_SLICE_BUTTON = 'wheel-slice--button';
const CLASS_ARROW_TOP = 'interactive-wheel--rotation-arrow-top';
const CLASS_ARROW_BOTTOM = 'interactive-wheel--rotation-arrow-bottom';

const CLASS_SLICE = 'wheel-slice';
const CLASS_LINK = 'wheel-slice--link';
const CLASS_TIER_LINK = 'wheel-slice--tier-link';

const CLASS_SECTION_SLICE = 'section-slice';
const CLASS_TIER_ONE = 'tier-one';
const CLASS_TIER_TWO = 'tier-two';

const CLASSROOT_COLOR = 'color--';

const VAR_SLICES_COUNT = '--slices-count';
const VAR_SLICES_CURRENT = '--current-slice';
const VAR_SLICE_INDEX = '--slice-index';
const VAR_ROTATION_SPEED_FACTOR = '--rotation-speed-factor';

const selectors = {
	wheel: CLASS_WHEEL,
	wheelContainer: CLASS_WHEEL_CONTAINER,
	backButton: CLASS_BACK_BUTTON,
	arrowTop: CLASS_ARROW_TOP,
	arrowBottom: CLASS_ARROW_BOTTOM,
	touchZone: CLASS_TOUCH_ZONE,
};
const selectorsAll = {
	slices: CLASS_SLICE,
};

const filterClass = (list, className) =>
	[...list].filter(element => element.classList.contains(className));
const filterSection = section => list =>
	//intended coertion
	[...list].filter(element => element.dataset.section == section);

module.exports = {
	async init() {
		fillWithDomElements(this, selectors);
		fillWithDomElementsAll(this, selectorsAll);
		if (!!this.root.dataset.oneLevel) {
			const firstSection = document.createElement('li');
			const secondSection = document.createElement('li');
			firstSection.classList.add(
				'wheel-slice',
				'active',
				'tier-group',
				'color--transparent',
				'one-level--first',
				'tier-one',
				'is-wide',
			);
			firstSection.innerHTML = `<svg viewBox="-0.5 0 11.4 11.4">
				<path id="tier-1-0"
					d="M10.7,5.7c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5S10.7,2.9,10.7,5.7z" fill="none" />
				<text>
					<textPath href="#tier-1-0" text-anchor="middle" startOffset="50%">
					${this.root.dataset.tierOneLabel}
					</textPath>
				</text>
			</svg>`;
			secondSection.classList.add(
				'wheel-slice',
				'active',
				'tier-group',
				'color--transparent',
				'one-level--second',
				'tier-two',
				'is-wide',
			);
			secondSection.innerHTML = `<svg viewBox="0 0 11.4 11.4">
				<path id="tier-2-2"
					d="M10.7,5.7c0-2.8-2.2-5-5-5s-5,2.2-5,5s2.2,5,5,5S10.7,8.5,10.7,5.7z" fill="none" />
				<text>
					<textPath href="#tier-2-2" text-anchor="middle" startOffset="50%">
					${this.root.dataset.tierTwoLabel}
					</textPath>
				</text>
			</svg>`;

			const sectionsArray = this.root.dataset.section
				.split(',')
				.filter(element => element);
			const sectionOneCount = sectionsArray.filter(
				element => element === '1',
			).length;
			const sectionTwoCount = sectionsArray.filter(
				element => element === '2',
			).length;

			if (sectionOneCount) {
				this.slices[0].before(firstSection);
				const sinOne = Math.sin(
					3.14159265359 * 2 * (sectionOneCount / sectionsArray.length),
				);
				const cosOne =
					sectionOneCount === 3
						? -1
						: Math.cos(
								3.14159265359 * 2 * (sectionOneCount / sectionsArray.length),
						  );
				firstSection.style.cssText += `--slice-index:0;--angle-sin:${sinOne}; --slice-width:${sectionOneCount};--angle-cos:${cosOne};`;
			}
			if (sectionTwoCount) {
				this.slices[sectionOneCount].before(secondSection);
				const sinTwo = Math.sin(
					3.14159265359 * 2 * (sectionTwoCount / sectionsArray.length),
				);
				const cosTwo = sectionTwoCount
					? -1
					: Math.cos(
							3.14159265359 * 2 * (sectionTwoCount / sectionsArray.length),
					  );
				secondSection.style.cssText += `--slice-index:${sectionOneCount};--angle-sin:${sinTwo}; --slice-width:${sectionTwoCount};--angle-cos:${cosTwo};`;
			}
		}

		this.wheel.style.setProperty('--additional-full-turn', 0);
		this.initValues();
		this.initEvents();
		await asyncImport(this, 'Hammer');
		this.initPanning();
		if (this.curentSection != null && !!!this.root.dataset.oneLevel) {
			this.setCurrent(0);
			this.level(1, this.curentSection);
		}
	},
	initValues() {
		this.previousPanDelta = 0;
		this.curentSection = this.root.dataset.section
			? Number(this.root.dataset.section)
			: undefined;

		this.slicesCount = Number(
			this.wheel.style.getPropertyValue(VAR_SLICES_COUNT),
		);
		this.wheelCursor = new WheelCursor(
			this.slicesCount,
			this.getWheelRotation(),
		);

		this.slicesSection = filterClass(this.slices, CLASS_SECTION_SLICE);
		this.slicesTierOne = filterClass(this.slices, CLASS_TIER_ONE);
		this.slicesTierTwo = filterClass(this.slices, CLASS_TIER_TWO);
	},
	initEvents() {
		this.wheelContainer.addEventListener('click', e => {
			const { target } = e;
			const { classList } = target;
			const className = [
				CLASS_BACK_BUTTON,
				CLASS_LINK,
				CLASS_TIER_LINK,
				CLASS_SLICE_BUTTON,
			].find(name => classList.contains(name));
			if (!className) return;
			({
				[CLASS_BACK_BUTTON]: () => {
					this.setCurrent(this.curentSection || 0);
					this.level(0, 0);
				},
				[CLASS_LINK]: () => {
					this.sliceTracking(e.target);
					this.onLinkClick(e);
				},
				[CLASS_TIER_LINK]: () => {
					this.sliceTracking(e.target);
				},
				[CLASS_SLICE_BUTTON]: this.onSliceButtonClick.bind(this, target),
			}[className]());
		});
	},
	onSliceButtonClick(target) {
		const slice = target.parentNode;
		const index = Number(slice.style.getPropertyValue(VAR_SLICE_INDEX));
		this.curentSection = index;
		this.setCurrent(0);
		this.level(1, index);
	},
	onLinkClick(e) {
		const { target } = e;
		const {
			parentNode: {
				dataset: { section },
			},
			href,
		} = target;
		e.preventDefault();
		(async () => {
			this.linkCancel && this.linkCancel();
			const { isCancelled, cancel } = registerCancelable();
			this.linkCancel = cancel;
			const next = Number(section || 0);
			if (this.wheelCursor.getSlice() !== next) {
				this.setCurrent(next);
				await awaitEventOnCondition(
					this.slicesSection[0],
					'transitionend',
					({ propertyName }) => propertyName === 'transform',
				);
				if (isCancelled()) return;
			}
			window.location.href = href;
		})();
	},
	initPanning() {
		[this.touchZone, this.wheelContainer].forEach(element => {
			const touch = new this.Hammer(element);
			touch.get('pan').set({ direction: DIRECTION_ALL });
			touch.on('panstart', this.onPanStart.bind(this));
			touch.on('pan', this.onPan.bind(this));
			touch.on('panend', this.onPanEnd.bind(this));
		});
	},
	onPanStart() {
		this.root.classList.add(CLASS_CONTROLLED);
		this.priorPanPosition = Number(
			this.wheel.style.getPropertyValue(VAR_SLICES_CURRENT),
		);
	},
	onPan({ deltaY }) {
		const newPos = this.priorPanPosition + deltaY / 200;
		this.setWheelRotation(newPos);
		this.arrowTop.classList.toggle(
			CLASS_ACTIVE,
			deltaY < this.previousPanDelta,
		);
		this.arrowBottom.classList.toggle(
			CLASS_ACTIVE,
			deltaY > this.previousPanDelta,
		);
		this.previousPanDelta = deltaY;
	},
	async onPanEnd() {
		this.previousPanDelta = 0;
		this.root.classList.remove(CLASS_CONTROLLED);
		this.setSpeedFactor(1);
		await awaitNextFrame();
		this.setWheelRotation(Math.round(this.getWheelRotation()));
		[this.arrowTop, this.arrowBottom].forEach(arrow =>
			arrow.classList.toggle(CLASS_ACTIVE, false),
		);
	},
	getEnabledAndDisabled(level, section) {
		const filter = filterSection(section);
		return (() => {
			if (level)
				return [
					[...filter(this.slicesTierOne), ...filter(this.slicesTierTwo)],
					this.slicesSection,
				];
			else
				return [
					this.slicesSection,
					[...this.slicesTierOne, ...this.slicesTierTwo],
				];
		})();
	},
	setBackButtonState(level, section) {
		const color = section != null && this.slicesSection[section].dataset.color;
		this.backButton.className =
			CLASS_BACK_BUTTON + ' ' + (level && color ? CLASSROOT_COLOR + color : '');
		this.backButton.disabled = !level;
	},
	async level(level, section) {
		this.currentCancel && this.currentCancel();
		const { isCancelled, cancel } = registerCancelable();
		this.currentCancel = cancel;
		await awaitNextFrame();
		if (isCancelled()) return;
		const [slices, slicesDisabled] = this.getEnabledAndDisabled(level, section);
		this.setSpeedFactor(4);
		this.setBackButtonState(level, section);
		setClassAll(slices, false, CLASS_NO_DISPLAY);
		await awaitNextFrame();
		if (isCancelled()) return;
		setClassAll(slices, true, CLASS_ACTIVE);
		setClassAll(slicesDisabled, false, CLASS_ACTIVE);
		await awaitEventOnCondition(
			slices[0],
			'transitionend',
			({ propertyName }) => propertyName === 'transform',
		);
		if (isCancelled()) return;
		setClassAll(slicesDisabled, true, CLASS_NO_DISPLAY);
	},
	setSpeedFactor(factor) {
		this.wheel.style.setProperty(VAR_ROTATION_SPEED_FACTOR, factor);
	},
	setWheelRotation(rotation) {
		this.wheel.style.setProperty(VAR_SLICES_CURRENT, rotation);
		this.wheelCursor.current = rotation;
	},
	getWheelRotation() {
		return Number(this.wheel.style.getPropertyValue(VAR_SLICES_CURRENT));
	},
	setCurrent(index) {
		const previousIndex = this.wheelCursor.current;
		const closestIndex = this.wheelCursor.setOnIndex(index);
		const rotationDifference = Math.abs(closestIndex - previousIndex);
		this.setSpeedFactor(rotationDifference || 1);
		this.setWheelRotation(closestIndex);
	},
	sliceTracking(target) {
		const { classList, textContent } = target;
		const level = classList.contains(CLASS_LINK) ? 1 : 2;
		trackGtm({
			eventCategory: 'sustainability wheel',
			eventAction: `level ${level}`,
			eventLabel: textContent,
		});
		trackGtm4({
			event: 'GA4_event_c_sustainability_wheel',
			link_text: textContent ? textContent.trim() : 'Text not set',
			link_url: target.href ? target.href : 'No url',
		});
	},
};
